import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.ModerationPieChartView extends Monitoring.Views.Charts.PieChartView

  initialize: ->
    @title = I18n.t('monitoring.dashboard.charts.moderation')
    @title_en = I18n.t('monitoring.dashboard.charts.moderation', {'locale': 'en'})
    super
    @url = '/monitoring/dashboard/charts/moderation'

  afterAppend: ->
    @ajaxCall(@url, @searchQuery.toJSON(), (response) =>
      @data = response
      super
    )
    return this

  getPieData: (name) ->
    return _.collect(@data, (value) =>
      [@replaceText(value.term), value.count]
    )

  getNewQuery: (event) =>
    query = @searchQuery.deepCopy()
    if event.point.name == 'Manual moderation'
      query.setManualModeration(true)
    else
      query.set('moderators', [ 'Robot' ])
      query.set('status', [ @replaceText(event.point.name) ])
    return query

  replaceText: (text) ->
    textLower = text.toLowerCase()
    hash = {
      'approved': 'Automatically Approved',
      'rejected': 'Automatically Rejected'
    }
    if hash[textLower]
      return hash[textLower]
    else
      value = _.invert(hash)[text]
      return if value then value else _.str.humanize(text)

  _benchmarkDataFromResponse: () ->
    _.map(@dataBenchmark, (data) => {name: @replaceText(data['term'].toLowerCase()), y: data['count']})
